import breakpoints from '../data/breakpoints';
import Slider from '../components/slider';

class Notes {
    constructor(el) {
        this.el = el;
        this.sliderEl = el.find('.slider');
        this.slider = new Slider(this.sliderEl, {
            dots: true,
            arrows: false,
            fade: true,
            responsive: [
                {
                    breakpoint: breakpoints.tablet - 1,
                    settings: {
                        centerMode: true,
                        centerPadding: '222px',
                        slidesToShow: 1,
                        fade: false,
                        infinite: true,
                        adaptiveHeight: false,
                        variableWidth: true
                    }
                },
                {
                    breakpoint: breakpoints.desktop - 1,
                    settings: 'unslick'
                }
            ]
        });
    }
}

export default Notes;